export function fixProductVariantSpacing(variantNumber: string) {
  return variantNumber.replaceAll(' ', '').replaceAll(':', ' : ').trim()
}
